module.exports = __webpack_public_path__ + "static/media/flights.81949a95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flights.png
// module id = 606
// module chunks = 0